import { createFileRoute } from '@tanstack/react-router'
import { AnomalyDetectionPage } from 'pages/anomalyDetection/AnomalyDetectionPage'

export const Route = createFileRoute('/anomaly-detection/$siteID/')({
  component: AnomalyDetectionPage,
  staticData: {
    title: 'Anomaly Detection',
    layout: {
      enableScrolling: true,
      enforceMaxWidth: true,
    },
  },
})
